import { useState } from "react";
import AcceleratorDoc from "../../models/AcceleratorDoc";
import { ExtractedData } from "../../models/extraction/ExtractedData";
import { HighlightColours } from "../../models/HighlightColors";
import { Hydratable } from "../../models/hydration/Hydratable";
import { Button } from "../buttons/Button";
import { HydratableDocError } from "../errorScreens/HydratableDocError";
import { TabList } from "../TabList";

type Props = {
  acceleratorDoc: Hydratable<AcceleratorDoc> | undefined;
};
const EfdDebugger = (props: Props) => {
  const [selectedEfds, setSelectedEfds] = useState<string[]>([]);
  const acceleratorDoc = props.acceleratorDoc?.isHydrated(false)
    ? props.acceleratorDoc.getHydrated()
    : undefined;

  // if no hydratable provided, no doc selected
  if (!acceleratorDoc) {
    return <HydratableDocError acceleratorDoc={props.acceleratorDoc} />;
  }

  const efds = acceleratorDoc.dlfs.get(acceleratorDoc.classifiedDocType);
  if (!efds) {
    return <span>No EFDs exist</span>;
  }
  // get all EFD names
  const efdNames = Array.from(efds.keys()) as string[];
  const visibleEfdNames = efdNames.filter((efd) => selectedEfds.includes(efd));
  const visibleEfds: any[] = [];
  efds.forEach((efd, key) => {
    if (visibleEfdNames.includes(key as string)) {
      visibleEfds.push(efd);
    }
  });
  return (
    <div>
      <Button
        onClick={() => {
          setSelectedEfds(
            (Array.from(efds.keys()) as string[]).filter((key) => {
              return efds.get(key)!.getReuse().length !== 0;
            }),
          );
        }}
      >
        EFDs with reuse
      </Button>
      <Button
        onClick={() => {
          setSelectedEfds(
            (Array.from(efds.keys()) as string[]).filter((key) => {
              return efds.get(key)!.getReuse().length === 0;
            }),
          );
        }}
      >
        EFDs without reuse
      </Button>
      <TabList changeSelectedTabs={setSelectedEfds} tabs={efdNames} />
      {Array.from(visibleEfds.values()).map((efd, i) => {
        return (
          <ExtractedDataDebugger key={efd.getName()} data={efd} index={i} />
        );
      })}
    </div>
  );
};

export { EfdDebugger, EtdDebugger };

const EtdDebugger = (props: Props) => {
  const [selectedEfds, setSelectedEfds] = useState<string[]>([]);
  const acceleratorDoc = props.acceleratorDoc?.isHydrated(false)
    ? props.acceleratorDoc.getHydrated()
    : undefined;

  // if no hydratable provided, no doc selected
  if (!acceleratorDoc) {
    return <HydratableDocError acceleratorDoc={props.acceleratorDoc} />;
  }

  const efds = acceleratorDoc.tables.get(acceleratorDoc.classifiedDocType);
  if (!efds) {
    return <span>No EFDs exist</span>;
  }
  // get all EFD names
  const efdNames = Array.from(efds.keys()) as string[];
  const visibleEfdNames = efdNames.filter((efd) => selectedEfds.includes(efd));
  const visibleEfds: any[] = [];
  efds.forEach((efd, key) => {
    if (visibleEfdNames.includes(key as string)) {
      visibleEfds.push(efd);
    }
  });
  return (
    <div>
      <Button
        onClick={() => {
          setSelectedEfds(
            (Array.from(efds.keys()) as string[]).filter((key) => {
              return efds.get(key)!.getReuse().length !== 0;
            }),
          );
        }}
      >
        EDs with reuse
      </Button>
      <Button
        onClick={() => {
          setSelectedEfds(
            (Array.from(efds.keys()) as string[]).filter((key) => {
              return efds.get(key)!.getReuse().length === 0;
            }),
          );
        }}
      >
        EFDs without reuse
      </Button>
      <TabList changeSelectedTabs={setSelectedEfds} tabs={efdNames} />
      {Array.from(visibleEfds.values()).map((efd, i) => {
        return (
          <ExtractedDataDebugger key={efd.getName()} data={efd} index={i} />
        );
      })}
    </div>
  );
};

type ExtractedDataDebuggerProps<T> = {
  data: ExtractedData<T>;
  index: number;
};
const ExtractedDataDebugger = <T,>(props: ExtractedDataDebuggerProps<T>) => {
  return (
    <div
      style={{
        backgroundColor: HighlightColours.getHighlightColor(props.index),
      }}
    >
      <h4>{props.data.getName()}</h4>
      <pre>
        {JSON.stringify(
          props.data,
          (key: string, val: any) => {
            if (key === "matcherData" || key === "_matcherData")
              return "NOT_SERIALIZED";
            if (key === "spanIds") return (val as any[]).length;
            return val;
          },
          2,
        )}
      </pre>
    </div>
  );
};
